import { Injectable } from '@angular/core';
import { ApiService, AppSettingsService } from '@woolworthsnz/styleguide';
import { Observable, catchError, of, throwError } from 'rxjs';
import { CountryOfOrigin } from '../../models';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class PricingService {
	constructor(private apiService: ApiService, private appSettingsService: AppSettingsService) {}

	getCountryOfOrigin = (sku: string, storeNumber: number | undefined): Observable<CountryOfOrigin | null> => {
		if (!sku || !storeNumber) {
			return of(null);
		}

		const endpoint = this.appSettingsService.settings.productAggregatorUrl;
		const route = `api/v1/store/${storeNumber}/article/${sku}/details/countryoforigin`;

		return this.apiService
			.getWithoutBaseHeaders<CountryOfOrigin>(`${endpoint}/${route}`, {})
			.pipe(catchError(this.handleError));
	};

	private handleError = (error: HttpErrorResponse): Observable<null> => {
		if (error.status === 404) {
			// Not found which is a valid response. Return empty instead of error so we can default to original behaviour.
			return of(null);
		} else {
			return throwError(
				() => new Error('A client-side or network error occurred occured when fetching the country of origin.')
			);
		}
	};
}
